// Enable selection of bulk checkboxes
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll("[data-behavior=bulk]").forEach((form) => {
    const checkboxSelector = `[name="${form.dataset.bulkId}[]"]`;
    const checkboxes = form.querySelectorAll(checkboxSelector);
    const selectedCheckboxes = () => form.querySelectorAll(`${checkboxSelector}:checked`);
    const buttons = form.querySelectorAll("[data-behavior=bulk-button]");
    const toggles = form.querySelectorAll("[data-behavior=bulk-toggle]");
    const allEnabled = () => {
      return selectedCheckboxes().length === checkboxes.length;
    };

    const disableAll = (nodes, disabled) => {
      if (disabled) {
        nodes.forEach((node) => node.setAttribute('disabled', ''));
      } else {
        nodes.forEach((node) => node.removeAttribute('disabled'));
      }
    };

    const checkAll = (nodes, checked) => {
      nodes.forEach((node) => node.checked = checked);
    };

    const handleChange = () => {
      disableAll(buttons, selectedCheckboxes().length === 0);
      checkAll(toggles, allEnabled());
    };

    checkboxes.forEach((checkbox) => checkbox.addEventListener('change', handleChange));

    toggles.forEach((toggle) => {
      toggle.addEventListener('change', (event) => {
        const target = event.target;
        checkAll(checkboxes, target.checked);
        disableAll(buttons, !target.checked);
      });
    });
  });
});
